const STEPS = [
  { tool: "crm.search", note: "account context · Orbit Pay" },
  { tool: "risk.score", note: "churn risk 0.82 · usage ↓ 42%" },
  { tool: "policy.check", note: "offer inside 15% guardrail" },
  { tool: "calendar.book", note: "Thu 11:00 with their CSM" },
];

export function createAiAgenticStage() {
  const wrap = document.createElement("div");
  wrap.className = "services-stage services-stage--agentic reveal";
  wrap.style.setProperty("--delay", "0.18s");
  wrap.setAttribute("aria-hidden", "true");

  wrap.innerHTML = `
    <div class="services-stage__glow"></div>
    <div class="services-stage__orb services-stage__orb--a"></div>
    <div class="services-stage__orb services-stage__orb--b"></div>
    <div class="services-stage__orb services-stage__orb--c"></div>

    <div class="services-stage__window services-stage__panel">
      <div class="services-stage__chrome">
        <span class="services-stage__dot services-stage__dot--r"></span>
        <span class="services-stage__dot services-stage__dot--y"></span>
        <span class="services-stage__dot services-stage__dot--g"></span>
        <span class="services-stage__path">copilot.taldel / ops</span>
        <span class="services-stage__live" data-live><span></span>thinking</span>
      </div>

      <div class="chat-stage">
        <div class="chat-stage__thread">
          <div class="chat-stage__msg chat-stage__msg--user">
            Resolve the VIP churn risk on Orbit Pay and book a save call — stay inside policy.
          </div>

          <div class="chat-stage__msg chat-stage__msg--ai">
            <span class="chat-stage__who"><i>AI</i>Ops copilot</span>
            <div class="chat-stage__steps" data-steps>
              ${STEPS.map(
                (s) => `
                <div class="chat-stage__step">
                  <span class="chat-stage__step-mark"></span>
                  <code>${s.tool}</code>
                  <small>${s.note}</small>
                </div>
              `
              ).join("")}
            </div>
            <div class="chat-stage__reply" data-reply>
              <div>
                <p>Booked Thu 11:00 with their CSM and drafted a retention offer — 15% for 6 months, inside policy. Want me to send it?</p>
                <div class="chat-stage__actions">
                  <span class="is-primary">Approve &amp; send</span>
                  <span>Edit offer</span>
                </div>
              </div>
            </div>
          </div>

          <div class="chat-stage__typing" data-typing><i></i><i></i><i></i></div>
        </div>

        <div class="chat-stage__input">
          <span>Ask the copilot…</span>
          <span class="chat-stage__send">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><path d="M12 19V5M6 11l6-6 6 6"/></svg>
          </span>
        </div>
      </div>

      <div class="services-stage__footer">
        <span>Evals on</span>
        <span>HITL ready</span>
        <span class="services-stage__pulse" data-pulse>calling tools</span>
      </div>
    </div>
  `;

  bindChatRuntime(wrap);
  return wrap;
}

function bindChatRuntime(root) {
  const reduced = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  const steps = [...root.querySelectorAll("[data-steps] .chat-stage__step")];
  const reply = root.querySelector("[data-reply]");
  const typing = root.querySelector("[data-typing]");
  const live = root.querySelector("[data-live]");
  const pulse = root.querySelector("[data-pulse]");

  const paint = (phase) => {
    // phase 0..steps.length-1: that step is running; steps.length: reply shown.
    steps.forEach((step, i) => {
      step.classList.toggle("is-done", i < phase);
      step.classList.toggle("is-active", i === phase);
    });
    const done = phase >= steps.length;
    if (reply) reply.classList.toggle("is-visible", done);
    if (typing) typing.classList.toggle("is-hidden", done);
    if (live) live.innerHTML = `<span></span>${done ? "awaiting approval" : "thinking"}`;
    if (pulse) pulse.textContent = done ? "human review" : `calling ${steps[phase]?.querySelector("code")?.textContent || "tools"}`;
  };

  if (reduced) {
    paint(steps.length);
    return;
  }

  let phase = 0;
  let timer = null;
  paint(phase);

  const tick = () => {
    phase = (phase + 1) % (steps.length + 2); // +2 holds the reply on screen a beat longer
    paint(Math.min(phase, steps.length));
  };

  const start = () => {
    if (timer) return;
    timer = window.setInterval(tick, 1500);
  };
  const stop = () => {
    if (!timer) return;
    clearInterval(timer);
    timer = null;
  };

  start();
  new IntersectionObserver(([entry]) => (entry.isIntersecting ? start() : stop()), {
    threshold: 0.2,
  }).observe(root);
}
